<template>
<w-sliding-popup ref="slidingPopup" type="setting" title="대상 설정" width="1200px" :default-content="false" @close="onClose">
  <div slot="content" class="body-content-no-scroll" style="height:100%;">
    <div style="height:100%; width: 500px; margin-right:20px; float:left;">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4">관리 대상</div>
      </el-row>
      <hr class="mr-b10" />
      <w-setting-target-obj-tree ref="settingTargetObjTree" :obj-view-type="objViewType" @setSelectedNode="setSelectedNode"></w-setting-target-obj-tree>
    </div>
    <!-- 자원 설정 -->
    <div style="height:100%; width:calc(100% - 520px); float:right;">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div>
          <span class="title-h4">{{rscSettingTitle}}</span>
        </div>
        <div>
          <el-button size="mini" type="primary" :disabled="!isAbleSave" @click="saveGuideInfo">저장</el-button>
          <el-button size="mini" :disabled="!isAbleSave" @click="revertRscTableInfo">취소</el-button>
          <w-header-search-button size="mini" @click="rscShowSearchTool = !rscShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper style="height:calc(100% - 41px);" :data="targetGuideTableData" :columns="targetGuideTableColumn" ref="guideTable" @select="targetSelectionChange" @select-all="checkSelectionAll"
        :total="total" :pagination="true" :fit-height="true" :show-search-tool="rscShowSearchTool" :show-custom-header="true" @condition-change="reload">
      </el-table-wrapper>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil, isEmpty, cloneDeep, find, findIndex, uniqBy } from 'lodash';
import msgUtil from '@/utils/message';
import EventGuideSettingsAPI from '@/api/settings/common/event-guide-settings';
import WSettingTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/SettingTargetObjTree';

/**
 * 이벤트 예측 대상 자원 설정 팝업
 * @author Ju
 */
export default {
  name: 'WEditGuideSettingPopup',
  components: {
    WSettingTargetObjTree,
  },
  data() {
    return {
      /**
       * 관리 대상 VIEW 타입 (논리/물리)
       * @type {String}
       */
      objViewType: null,
      selectedObj: null,
      rscShowSearchTool: false,
      isAbleSave: false,
      selectionList: [],
      originTableData: [],
      total: 0,
      targetGuideTableData: [],
      originCheckList: [],
      targetGuideTableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: true,
          searchable: true,
        },
      ],
      isFirstLoadTable: false,
    };
  },
  computed: {
    /**
     * 임계치 가이드 자원 설정 타이틀
     * @author Ju
     * @return {String}
     */
    rscSettingTitle() {
      const title = '임계치 가이드 자원';
      return isNil(this.selectedObj) ? title : `[${this.selectedObj.objName}] ${title}`;
    },
  },
  watch: {
    selectedObj: {
      handler(to) {
        if (!isEmpty(to)) {
          this.$refs.guideTable.clearFilter();
          this.selectionList = [];
          this.targetGuideTableData = [];
          this.loadTargetEventGuideInfo();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 팝업을 연다.
     * @author Ju
     */
    open() {
      this.$refs.slidingPopup.open();
      this.objViewType = 'LOGICAL';
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     */
    onClose() {
      this.selectedObj = null;
      this.objViewType = null;
      this.rscShowSearchTool = false;
      this.targetGuideTableData = [];
      this.$refs.guideTable.clearFilter();
      this.$refs.settingTargetObjTree.initData();
      this.$emit('reload');
    },
    /**
     * 임계치 가이드 자원 목록을 설정한다.
     * @author yelim
     */
    loadTargetEventGuideInfo() {
      const tableParams = this.$refs.guideTable.getParameter();
      const params = {
        objId: this.selectedObj.objId,
        ...tableParams,
      };
      EventGuideSettingsAPI.getSettingEventGuideRscTree(params).then((response) => {
        if (response.data.success) {
          const tableRef = this.$refs.guideTable.$children[0];
          this.originTableData = cloneDeep(response.data.data);
          this.targetGuideTableData = response.data.data;
          this.total = response.data.total;
          this.$nextTick(() => {
            // 로드된 목록이 자원으로 선택되어 있는 경우 그리드에 check 설정을 한다.
            this.targetGuideTableData.forEach((item) => {
              if (item.checkGuide === 1) {
                this.originCheckList.push(item);
                this.selectionList.push(item);
                tableRef.toggleRowSelection(item);
              }
            });
            this.isFirstLoadTable = true;
            if (isEmpty(this.selectionList)) {
              this.isAbleSave = false;
            }
          });
        }
      });
    },
    /**
     * 선택한 임계치 가이드 예측 자원을 리스트에 설정
     * @author yelim
     */
    targetSelectionChange(rows, row) {
      let changeFlag = false;
      if (this.originCheckList.length !== rows.length) {
        changeFlag = true;
      } else {
        rows.forEach((targetItem) => {
          const findChange = find(this.originCheckList, (originInfo) => originInfo.hashKeyIdString === targetItem.hashKeyIdString);
          if (!findChange) {
            changeFlag = true;
          }
        });
      }
      if (this.isFirstLoadTable === true) {
        const targetTableData = this.targetGuideTableData;
        const toggleCheckData = findIndex(targetTableData, (item) => row.hashKeyIdString === item.hashKeyIdString);
        targetTableData[toggleCheckData].checkGuide = !(targetTableData[toggleCheckData].checkGuide);
        if (!targetTableData[toggleCheckData].checkGuide) {
          targetTableData[toggleCheckData].importantRsc = false;
        }
        this.targetGuideTableData = targetTableData;
      }
      this.selectionList = uniqBy(rows, 'hashKeyIdString');
      this.isAbleSave = changeFlag;
    },
    /**
     * 선택한 대상에 임계치 가이드 자원을 설정 및 삭제한다
     * @author yelim
     */
    saveGuideInfo() {
      const insertList = [];
      const deleteList = [];
      // 추가 목록
      this.selectionList.forEach((item) => {
        const findChange = find(this.originTableData, (originInfo) => originInfo.hashKeyIdString === item.hashKeyIdString);
        if (findChange) {
          if (findChange.checkGuide === 0) {
            insertList.push({ hashkeyId: item.hashKeyIdString });
          }
        }
      });
      // 삭제 목록
      this.originTableData.forEach((item) => {
        const findChange = find(this.selectionList, (selectInfo) => selectInfo.hashKeyIdString === item.hashKeyIdString);
        if (isNil(findChange) && item.checkGuide === 1) {
          deleteList.push({ hashkeyId: item.hashKeyIdString });
        }
      });
      this.originCheckList = [];
      EventGuideSettingsAPI.updateGuideRscInfo({ insertList, deleteList }).then((response) => {
        if (response.data.success) {
          this.loadTargetEventGuideInfo();
          this.isAbleSave = false;
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', false));
      });
    },
    /**
     * 취소 버튼을 누르면 원 상태로 복구한다.
     * @author yelim
     */
    revertRscTableInfo() {
      this.originCheckList = [];
      this.selectionList = [];
      const tableRef = this.$refs.guideTable.$children[0];
      this.targetGuideTableData = cloneDeep(this.originTableData);
      this.$nextTick(() => {
        this.targetGuideTableData.forEach((item) => {
          if (item.checkGuide === 1) {
            this.originCheckList.push(item);
            tableRef.toggleRowSelection(item);
          }
        });
      });
      this.isAbleSave = false;
    },
    reload() {
      this.loadTargetEventGuideInfo();
    },
    /**
     * 트리 컴포넌트에서 선택한 obj를 받아온다.
     * @author yelim
     * @param  {[type]} objNode [description]
     */
    setSelectedNode(objNode) {
      this.isFirstLoadTable = false;
      this.originCheckList = [];
      this.selectedObj = objNode;
    },
    checkSelectionAll(selection) {
      // all selection 이벤트는 모두 선택하거나 선택을 해제하는 경우밖에 없음.
      const targetTableData = this.targetGuideTableData;
      this.$nextTick(() => {
        if (isEmpty(selection)) {
          targetTableData.forEach((item) => {
            if (item.checkGuide) {
              item.importantRsc = false;
              item.checkGuide = !(item.checkGuide);
            }
          });
          if (isEmpty(this.selectionList)) {
            this.isAbleSave = false;
          } else {
            this.isAbleSave = true;
          }
          this.selectionList = [];
        } else {
          selection.forEach((selectionInfo) => {
            const toggleCheckData = findIndex(targetTableData, (item) => selectionInfo.hashKeyIdString === item.hashKeyIdString);
            if (!targetTableData[toggleCheckData].checkGuide) {
              targetTableData[toggleCheckData].checkGuide = !(targetTableData[toggleCheckData].checkGuide);
            }
          });
          this.isAbleSave = true;
          this.selectionList = uniqBy(selection, 'hashKeyIdString');
        }
        this.targetGuideTableData = targetTableData;
        this.selectionList = isEmpty(selection) ? [] : uniqBy(selection, 'hashKeyIdString');
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/popup/EditGuideSettingPopup.vue